<template>
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="visible" width="600px">


        <el-row>
            <el-col :span="24" class="row-form-item">
                <div class="fileItem">检验意见</div>
            </el-col>
        </el-row>

        <el-row class="set_border">
            <el-col :span="24">
                <div class="set_data">{{ sutContent }}</div>
            </el-col>
        </el-row>

        <el-row style="margin-top: 2px;margin-bottom: 10px;">
            <el-col :span="24">
                <div style="margin-left: 2px;">
                    <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="tracking">
                    </el-input>
                </div>
            </el-col>
        </el-row>
        <el-row class="formBtnGroup">
            <el-button v-preventReClick class="btn" type="primary" size="small" @click="dataFormSubmit()">确定</el-button>
            <el-button v-preventReClick class="btn" type="primary" size="small" @click="visible = false">取消</el-button>
        </el-row>
    </el-dialog>
</template>

<script>
import $common from "@/utils/common.js"
export default {
    name: "tracking-dialog",
    data() {
        return {
            title: '跟踪意见',
            testId: '',
            visible: false,
            tracking: '',
            sutContent: ''
        };
    },
    methods: {
        init(id) {
            this.testId = id || '';
            this.getDetail();
            this.$nextTick(() => {
                this.visible = true;
            });
        },

        getDetail() {
            this.$http({
                url: this.$store.state.httpUrl + "/business/testrecord/info/" + this.testId,
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.tracking = data.body.tracking;
                    this.sutContent = data.body.sutContent;
                }
            });
        },

        dataFormSubmit() {
            let _url = "/business/testrecord/trackingTestRecord";
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData({
                    testId: this.testId,
                    tracking: this.tracking,
                })
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                        onClose: () => {
                            this.visible = false;
                            // 数据更新成功后，触发事件通知父组件刷新数据
                            this.$emit('refreshDataList');
                        }
                    });
                }
            });
        }
    }
};
</script>

<style scoped="scoped">
::v-deep .el-dialog__header {
    height: 60px;
    line-height: 30px;
}
.set_border {
    border-bottom: 1px solid #dadada;
    border-left: 1px solid #dadada;
    border-right: 1px solid #dadada;
}

.set_data {
    font-size: 14px;
    padding: 5px 20px !important;
    width: 100% !important;
    height: auto !important;
    min-height: 60px;
}
</style>
